import { render } from "./thisComponent.vue?vue&type=template&id=e4265936&scoped=true"
import script from "./thisComponent.vue?vue&type=script&lang=js"
export * from "./thisComponent.vue?vue&type=script&lang=js"

import "./thisComponent.vue?vue&type=style&index=0&id=e4265936&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4265936"]])

export default __exports__